export default function LoginForm({credentials, setCredentials, handleLogin}) {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials((prevCredentials) => ({
            ...prevCredentials,
            [name]: value,
        }));
    };
    return (
        <form onSubmit={handleLogin}>
            <label>
                <p>Imię:</p>
                <input
                    type="text"
                    value={credentials.name}
                    name="name"
                    onChange={handleChange}
                    required
                />
            </label>
            <label>
                <p>Kod PIN:</p>
                <input
                    type="number"
                    value={credentials.code}
                    name="code"
                    onChange={handleChange}
                    required
                />
            </label>
            <input type="submit" value="zaloguj się"/>
        </form>
    )
}